var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgHealthyLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 264,
    height: 54
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "healthy-logo_svg__a",
    d: "M0 63.143h271.825V.16H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0F0238",
    d: "M77.57 24.869H56.199v17.268h-2.936V4.95h2.936v17.118h21.373V4.95h2.936v37.187h-2.936z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-6 -3.1)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0F0238",
    d: "M92.637 30.82h20.257c-.555-5.346-4.354-8.963-9.975-8.963-5.318 0-9.472 3.82-10.282 8.963m-2.834 1.836c0-7.54 5.57-13.4 13.116-13.4 7.392 0 12.964 5.299 12.964 12.94v1.272H92.535c.406 5.604 4.558 9.68 10.536 9.68 4.71 0 7.9-2.445 9.571-6.368l2.533 1.225c-2.281 4.89-6.179 7.741-12.054 7.741-8.205 0-13.318-5.654-13.318-13.09m52.669-.154c0-5.808-4.505-10.595-10.38-10.595-5.724 0-10.282 4.737-10.282 10.595 0 5.86 4.558 10.594 10.281 10.594 5.876 0 10.381-4.735 10.381-10.594m-23.549 0c0-7.286 5.572-13.245 13.016-13.245 3.848 0 8.152 2.089 10.23 5.809v-5.298h2.886v25.47h-2.887v-5.299c-2.077 3.718-6.38 5.807-10.229 5.807-7.395 0-13.016-5.96-13.016-13.244"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "healthy-logo_svg__b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#healthy-logo_svg__a"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#0F0238",
    d: "M151.287 45.237h2.937V8.05h-2.937zm6.179-25.469h4.353v-5.96l2.94-1.734v7.694h6.43v2.597h-6.43v13.551c0 5.654 1.115 6.621 6.43 6.621v2.7h-.403c-7.041 0-8.967-1.936-8.967-9.27V22.364h-4.353v-2.597zM175.141 8.05h2.837v16.404c1.771-3.056 5.166-5.198 9.42-5.198 6.735 0 11.193 4.434 11.193 11.72v14.261h-2.939V30.975c0-5.453-3.088-9.066-8.66-9.066-5.064 0-8.964 3.92-8.964 9.116v14.212h-2.887V8.05zm37.833 35.76l-11.193-24.042h3.191l9.574 20.73 8.912-20.73h3.14L210.24 57.003h-3.089zm13.626 1.427h2.936v-6.98h-2.937zm9.925 0h2.887v-25.47h-2.887v25.47zm0-29.8h2.887V8.05h-2.887v7.388zm30.337 17.065c0-5.858-4.509-10.595-10.23-10.595-5.723 0-10.231 4.737-10.231 10.595 0 5.86 4.508 10.594 10.231 10.594 5.721 0 10.23-4.735 10.23-10.594m-23.348 0c0-7.436 5.826-13.245 13.118-13.245 7.293 0 13.166 5.809 13.166 13.245 0 7.437-5.873 13.244-13.166 13.244-7.292 0-13.118-5.807-13.118-13.244M6.16 45.24h41.49V3.508H6.16v41.73zm2.199-2.212h37.097V5.715H8.359v37.313z",
    mask: "url(#healthy-logo_svg__b)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0F0238",
    d: "M17.03 45.237h2.196V3.507H17.03zm19.443-20.864h2.193V3.509h-2.193z",
    mask: "url(#healthy-logo_svg__b)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0F0238",
    d: "M18.13 25.476h28.707v-2.209H18.13z",
    mask: "url(#healthy-logo_svg__b)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#E74D5F",
    d: "M2.359 2.615h8.7V39.93h-8.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F5BB33",
    d: "M13.216 22.376h26.24v17.553h-26.24z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M13.216 2.615h17.279v17.58H13.216zm19.432 0h6.808v17.58h-6.808z"
  }))));
}

export default SvgHealthyLogo;